import { makeStyles, tokens } from '@fluentui/react-components';

export const useTemplateVideoStyles = makeStyles({
  videoCard: {
    height: '100%',
    width: '100%',
    maxWidth: '100%',
    filter: 'drop-shadow(0px 0.3px 0.9px rgba(0, 0, 0, 0.1)) drop-shadow(0px 1.6px 3.6px rgba(0, 0, 0, 0.13))',
    padding: `${tokens.spacingVerticalNone}, ${tokens.spacingHorizontalNone}`,
    borderRadius: '6px',
  },
  videoCardThumbnail: {
    objectFit: 'cover',
    overflow: 'hidden',
  },
  flexColumn: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
  },
  templateWithCaption: {
    gap: tokens.spacingVerticalM,
  },
  caption: {
    gap: tokens.spacingVerticalXS,
  },
  darkGrayText: {
    color: '3B3B4F',
  },
  grayText: {
    color: tokens.colorNeutralForeground3,
  },
});

export const useTemplateGridStyles = makeStyles({
  gridContainer: {
    marginTop: tokens.spacingVerticalXXL,
  },
  skeletonContainer: {
    alignItems: 'center',
    display: 'grid',
    position: 'relative',
    gridTemplateColumns: 'repeat(5, 1fr)',
    gap: tokens.spacingVerticalL,
  },
  templateBody: {
    paddingTop: '10px',
  },
  filtersRow: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    marginTop: '15px',
    gap: tokens.spacingHorizontalS,
  },
  filterButton: {
    minWidth: 'auto',
    whiteSpace: 'nowrap',
  },
  screenReaderOnly: {
    position: 'absolute',
    height: '1px',
    width: '1px',
    clip: 'rect(1px 1px 1px 1px)', // IE 6 and 7
    'clip-path': 'polygon(0px 0px, 0px 0px, 0px 0px)',
    '-webkit-clip-path': 'polygon(0px 0px, 0px 0px, 0px 0px)',
    overflow: 'hidden !important',
  },
});
